module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_f_albino.21233427.png";